


























import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import InformationKey from "@/components/information-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const informationStore = inject(InformationKey);
    if (!informationStore) {
      throw new Error(`${InformationKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const loadedFlag = ref<boolean>(false);

    const member = computed(() => memberStore.member);
    const memberResponse = computed(() => memberStore.response);

    const informationHeaders = computed(
      () => informationStore.informationHeaders
    );
    const informationList = computed(() => informationStore.informationList);
    const newInformationFlag = computed(
      () => informationStore.newInformationFlag
    );
    const latestInformationId = computed(
      () => informationStore.latestInformationId
    );
    const informationResponse = computed(() => informationStore.response);

    const linkTo = (row: any) => {
      context.root.$router.push({
        name: "MemberInformationDetail",
        params: { id: row.id }
      });
    };

    onMounted(async () => {
      loadedFlag.value = false;
      memberStore.setAuthorizationHeader(accessToken.value);
      informationStore.setAuthorizationHeader(accessToken.value);

      const p1 = memberStore.getMember();
      const p2 = informationStore.getInformationCategoryList();

      await Promise.allSettled([p1, p2]);

      if (
        memberResponse.value.status < 400 &&
        informationResponse.value.status < 400
      ) {
        await informationStore.getInformationList();
        informationStore.setNewInformationFlag(member.value.checked_notice_id); // 表示ステータス更新
        if (newInformationFlag.value && latestInformationId.value) {
          memberStore.updateCheckInformation(latestInformationId.value); // 更新
          informationStore.setNewInformationFlag(latestInformationId.value); // 表示ステータス更新
        }
      }

      loadedFlag.value = true;
    });

    return {
      loadedFlag,
      informationHeaders,
      informationList,
      linkTo
    };
  },
  components: {}
});
